export default __webpack_public_path__ + "static/media/icon-file-green.57ba472d.svg";